import type { LegalDoc } from "../types";
import { LEGAL_COMPANY as C } from "../company";

export const eula: LegalDoc = {
  slug: "eula",
  title: "Thoả thuận giấy phép người dùng cuối (EULA)",
  metaTitle: "EULA",
  metaDescription:
    "Thoả thuận giấy phép sử dụng phần mềm Chốt Ca cho người dùng cuối, áp dụng cho phiên bản iOS và Android.",
  version: "2.0.0",
  effectiveDate: C.effectiveDate,
  intro: `Thoả thuận giấy phép người dùng cuối này (**"EULA"**) là hợp đồng giữa bạn và **${C.legalName}** về việc cấp giấy phép sử dụng phần mềm ứng dụng Chốt Ca trên iOS, Android và các nền tảng khác (**"Phần mềm"**). EULA này bổ sung cho [Điều khoản sử dụng](/terms) và đáp ứng yêu cầu của **Apple App Store** cùng **Google Play** đối với ứng dụng có nội dung do người dùng tạo.`,
  sections: [
    {
      title: "1. Cấp phép",
      body: "Chúng tôi cấp cho bạn giấy phép **không độc quyền, không chuyển nhượng, có thể thu hồi, có giới hạn**, miễn phí, để cài đặt và sử dụng Phần mềm trên thiết bị cá nhân thuộc sở hữu hoặc kiểm soát của bạn, chỉ cho mục đích sử dụng thông thường theo [Điều khoản sử dụng](/terms).",
    },
    {
      title: "2. Hạn chế",
      body: "Bạn cam kết KHÔNG:",
      items: [
        "Sao chép, phân phối lại, bán, cho thuê hoặc cấp phép lại Phần mềm.",
        "Đảo ngược, dịch ngược, tách rời hoặc tìm cách chiết xuất mã nguồn, trừ phạm vi pháp luật cho phép minh thị.",
        "Gỡ bỏ, làm mờ hoặc thay đổi thông báo bản quyền, nhãn hiệu trong Phần mềm.",
        "Sử dụng Phần mềm để phát triển sản phẩm cạnh tranh.",
        "Truy cập Phần mềm bằng phương thức tự động như bot hoặc trình thu thập dữ liệu.",
        "Can thiệp, làm quá tải hoặc thử khai thác lỗ hổng của hệ thống Chốt Ca.",
      ],
    },
    {
      title: "3. Nội dung do người dùng tạo và cơ chế kiểm duyệt",
      body: "Chốt Ca có nội dung do người dùng đăng tải, gồm tin tuyển dụng, hồ sơ cá nhân và ảnh. Chúng tôi duy trì các cơ chế sau để xử lý nội dung vi phạm:",
      items: [
        "**Báo cáo**: nút báo cáo có sẵn trên mọi tin tuyển dụng, hồ sơ và doanh nghiệp.",
        "**Ẩn và chặn**: Người tìm việc ẩn một doanh nghiệp để doanh nghiệp đó không thấy và không liên hệ được. Nhà tuyển dụng đưa một người vào danh sách chặn để người đó không ứng tuyển vào tin của mình.",
        "**Kiểm duyệt nội dung tin**: hệ thống kiểm tra tiêu đề và mô tả tin để chặn nội dung vi phạm và việc chèn số liên hệ nhằm kéo người dùng ra ngoài Nền tảng.",
        "**Xử lý của con người**: quản trị viên xem xét và xử lý báo cáo về nội dung vi phạm trong **24 giờ**.",
        "**Gỡ bỏ và chấm dứt**: nội dung vi phạm bị gỡ ngay khi được xác minh; tài khoản vi phạm nghiêm trọng hoặc tái phạm bị chấm dứt.",
        "Chốt Ca **không có tính năng nhắn tin trong ứng dụng**, nên không phát sinh nội dung hội thoại riêng tư giữa người dùng trên Phần mềm.",
      ],
    },
    {
      title: "4. Không khoan nhượng với nội dung vi phạm",
      body: 'Phù hợp với Nguyên tắc rà soát ứng dụng 1.2 của Apple về nội dung phản cảm, chúng tôi áp dụng chính sách **"không khoan nhượng"** với:',
      items: [
        "Nội dung khiêu dâm, tình dục hoá, kích động bạo lực, phân biệt chủng tộc, kỳ thị giới tính.",
        "Hành vi quấy rối, bắt nạt, đe doạ.",
        "Tuyển dụng cho công việc trái pháp luật, mại dâm, ma tuý, cờ bạc.",
        "Lừa đảo, đa cấp biến tướng, mạo danh thương hiệu.",
        "Thư rác và quảng cáo trá hình.",
        "Sử dụng lao động chưa thành niên trái pháp luật.",
      ],
    },
    {
      title: "5. Cập nhật phần mềm",
      body: "Chúng tôi phát hành bản cập nhật, vá lỗi và tính năng mới qua App Store và Google Play, đồng thời cập nhật từ xa đối với nội dung không phải mã thực thi như tài liệu pháp lý và cấu hình. Một số bản cập nhật có thể là bắt buộc để tiếp tục sử dụng Phần mềm, đặc biệt khi liên quan tới bảo mật hoặc thay đổi giao thức máy chủ.",
    },
    {
      title: "6. Quyền sở hữu",
      body: `Phần mềm được cấp phép, **không** được bán. ${C.legalName} và các bên cấp phép giữ toàn bộ quyền sở hữu trí tuệ đối với Phần mềm, bao gồm mã nguồn, giao diện, biểu tượng và tài liệu kèm theo, được bảo hộ theo Luật Sở hữu trí tuệ Việt Nam.`,
    },
    {
      title: "7. Phần mềm bên thứ ba",
      body: "Phần mềm sử dụng các thư viện mã nguồn mở và dịch vụ bên thứ ba, gồm React Native, Expo, Firebase và Sentry. Việc sử dụng các thành phần này tuân thủ giấy phép tương ứng của từng thư viện. Danh sách chi tiết có trong ứng dụng tại Cài đặt, mục Giấy phép mã nguồn mở.",
    },
    {
      title: "8. Tuyên bố về bảo đảm",
      body: `Phần mềm được cung cấp **theo hiện trạng** và **theo tính sẵn có**. Trong phạm vi pháp luật cho phép, ${C.legalName} không bảo đảm rằng Phần mềm sẽ hoạt động không gián đoạn, không lỗi, hoặc phù hợp với một mục đích cụ thể của bạn. Tuyên bố này **không loại trừ** các bảo đảm mà pháp luật Việt Nam về bảo vệ quyền lợi người tiêu dùng quy định là không thể loại trừ.`,
    },
    {
      title: "9. Giới hạn trách nhiệm",
      body: `Trong phạm vi pháp luật cho phép, tổng trách nhiệm của ${C.legalName} đối với bạn cho mọi khiếu nại liên quan tới Phần mềm không vượt quá tổng phí bạn đã trả cho Chốt Ca trong **12 tháng** trước thời điểm phát sinh khiếu nại, hoặc **một triệu đồng (1.000.000 VND)**, tuỳ số nào lớn hơn.\n\nGiới hạn này **không áp dụng** đối với thiệt hại do lỗi cố ý hoặc lỗi nghiêm trọng của Chốt Ca, thiệt hại về tính mạng và sức khoẻ, và các trường hợp khác mà pháp luật Việt Nam không cho phép giới hạn trách nhiệm.`,
    },
    {
      title: "10. Điều khoản đặc thù cho App Store",
      body: "Đối với Phần mềm tải xuống từ Apple App Store, bạn xác nhận:",
      items: [
        "EULA này là giao kết giữa bạn và Chốt Ca, **không phải** với Apple. Apple không chịu trách nhiệm về Phần mềm hoặc nội dung của nó.",
        "Apple không có nghĩa vụ cung cấp dịch vụ bảo trì hay hỗ trợ cho Phần mềm.",
        "Trường hợp Phần mềm không phù hợp với bảo đảm áp dụng, bạn có thể yêu cầu Apple hoàn tiền giá mua nếu có; ngoài phạm vi đó, Apple không có thêm nghĩa vụ bảo đảm nào.",
        "Apple và các công ty con của Apple là **bên thụ hưởng thứ ba** của EULA này và có quyền thực thi EULA đối với bạn sau khi bạn chấp nhận.",
        "Khiếu nại liên quan tới tuân thủ pháp luật bảo vệ người tiêu dùng được giải quyết giữa bạn và Chốt Ca; Apple không chịu trách nhiệm.",
        "Khiếu nại của bên thứ ba cho rằng Phần mềm xâm phạm quyền sở hữu trí tuệ được xử lý bởi Chốt Ca, không phải Apple.",
      ],
    },
    {
      title: "11. Chấm dứt",
      body: "EULA có hiệu lực cho tới khi chấm dứt. Quyền của bạn theo EULA tự động chấm dứt nếu bạn không tuân thủ bất kỳ điều khoản nào. Khi chấm dứt, bạn phải gỡ Phần mềm khỏi mọi thiết bị. Việc chấm dứt EULA không tự động xoá dữ liệu tài khoản của bạn — xem [Hướng dẫn xoá dữ liệu](/data-deletion).",
    },
    {
      title: "12. Luật áp dụng",
      body: "EULA được điều chỉnh bởi pháp luật Việt Nam. Toà án nhân dân có thẩm quyền tại Thành phố Hồ Chí Minh giải quyết các tranh chấp phát sinh, trừ các điều khoản đặc thù dành cho App Store nêu tại mục 10.",
    },
  ],
  contact: {
    title: "13. Liên hệ",
    prefix: "Câu hỏi về EULA xin gửi về ",
    email: C.legalEmail,
  },
};
